// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import markerPin01Icon from "@/assets/icons/marker-pin-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MarkerPin01IconProps = Omit<IconProps, "name">;

export function MarkerPin01Icon(props: MarkerPin01IconProps): React.ReactNode {
  return <Icon name={markerPin01Icon} {...props} />;
}
